import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

export default function dateFormatters() {
  const formatDate = (date: string, format: string): string => {
    return dayjs(date).utc().format(format);
  };

  return {
    formatDate
  };
}
